import { useMemo } from 'react';
import Link from 'next/link';
import { cx } from '@/utils';
import { useLayoutContext } from '@common/Layout/LayoutProvider/LayoutContext';

import { ImageOrSvg } from '../../ImgOrSvg';

const SocialNetworks = ({ color = 'text-primary' }) => {
  const {
    layout: { pageFooterBar },
  } = useLayoutContext();
  const socialNetworkItem = useMemo(() => {
    if (pageFooterBar?.items) {
      return pageFooterBar.items.filter((item) => item.footerType === 'IsSocialNetwork');
    }
    return [];
  }, [pageFooterBar?.items]);

  return (
    <div className={'mt-5 flex flex-row flex-wrap items-center gap-8'}>
      {socialNetworkItem
        .filter((x) => x.hasSocialNetworkIcon)
        .map((value, key) => (
          <Link
            href={value.socialNetworkLink || '#'}
            className={'flex flex-row items-center gap-2'}
            target={'_blank'}
            key={key}
          >
            {value.socialNetworkIcon &&
              value.socialNetworkName &&
              value.socialNetworkIcon.downloadUrl && (
                <ImageOrSvg
                  height={32}
                  width={32}
                  url={value.socialNetworkIcon.downloadUrl}
                  alt={`${value.socialNetworkName} icon`}
                  classNameSvg="text-primary [&>svg]:!size-[32px] [&_*]:!fill-primary"
                />
              )}
            <div className={cx(color)}>{value.socialNetworkName}</div>
          </Link>
        ))}
    </div>
  );
};

export default SocialNetworks;
